import { MaybePromise } from "@homebound/activesupport";
import { Button, Css, GridTableApi, IconButton, Palette, useComputed } from "@homebound/beam";

export type CollapseRowToggleProps = {
  rowId: string;
  label: string;
  api: GridTableApi<any>;
  compact?: boolean;
  onCollapse?: () => MaybePromise<void>; // Optional callback when the row is collapsed
  muted?: boolean;
};

/** Wraps `CollapseToggle` and adds a button label. */
export function CollapseRowToggle({
  api,
  rowId,
  label,
  onCollapse,
  compact = false,
  muted = false,
}: CollapseRowToggleProps) {
  const isCollapsed = useComputed(() => api.isCollapsedRow(rowId), [api]);
  const iconKey = isCollapsed ? "chevronRight" : "chevronDown";
  const toggleCollapsedRow = async () => {
    api.toggleCollapsedRow(rowId);
    isCollapsed && (await onCollapse?.());
  };

  return (
    <div css={Css.df.jcc.if(muted).blue200.$}>
      <Button variant="text" label={label} onClick={toggleCollapsedRow} />
      <IconButton onClick={toggleCollapsedRow} icon={iconKey} color={muted ? Palette.Blue200 : undefined} />
    </div>
  );
}
